module.exports = __webpack_public_path__ + "static/media/giro_horizontal.2164eff8.png";